const isBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
// Set the name of the hidden property and the change event for visibility
let hiddenProp;
let visibilityChangeEventName;
if (isBrowserEnv) {
    const htmlDocument = document;
    if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hiddenProp = 'hidden';
        visibilityChangeEventName = 'visibilitychange';
    }
    else if (typeof htmlDocument.msHidden !== 'undefined') {
        hiddenProp = 'msHidden';
        visibilityChangeEventName = 'msvisibilitychange';
    }
    else if (typeof htmlDocument.webkitHidden !== 'undefined') {
        hiddenProp = 'webkitHidden';
        visibilityChangeEventName = 'webkitvisibilitychange';
    }
}
/**
 * Wrapper for browser's Page Visibility API. Comes with a node interface to run it save in server-side rendering scenarios.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API | Page Visibility API}
 */
export default {
    isSupported: isBrowserEnv &&
        typeof document.addEventListener !== 'undefined' &&
        hiddenProp !== undefined,
    hiddenProp,
    visibilityChangeEventName
};
